import React from 'react';
import { styled } from '@linaria/react';
import { ControlWithCheckmark } from '@daedalus/atlas/helpers/ControlWithCheckmark';
import { SelectionCard } from '@daedalus/atlas/SelectionCard';
interface Props<T> {
  item: T;
  getValue: (item: T) => string;
  renderItem: (item: T, isMobile: boolean) => React.ReactNode;
  isMobile: boolean;
  isActive: boolean;
  onClick: (code: string) => void;
}
const ListItemWrapper = /*#__PURE__*/styled('li')({
  name: "ListItemWrapper",
  class: "lhyaryu",
  propsAsIs: false
});
const FlexGrow = /*#__PURE__*/styled('div')({
  name: "FlexGrow",
  class: "fimn6gg",
  propsAsIs: false
});
export const SelectorListItem = <T,>({
  isActive,
  isMobile,
  item,
  onClick,
  renderItem,
  getValue
}: Props<T>) => {
  const value = getValue(item);
  if (isMobile) {
    return <ListItemWrapper onClick={() => {
      onClick(value);
    }}>
        <FlexGrow>{renderItem(item, isMobile)}</FlexGrow>
        {isActive && <ControlWithCheckmark type="radio" checked name={value} />}
      </ListItemWrapper>;
  }
  return <SelectionCard size="md" type="radio" name={value} withBorder={isActive} withControlButton={isActive} selected={isActive} alignCheckmark="center" onChange={() => {
    onClick(value);
  }}>
      {renderItem(item, isMobile)}
    </SelectionCard>;
};

require("./SelectorListItem.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SelectorListItem.tsx");